import { CrashDescription, IssueTag } from '../../../common/src/model.ts';
import * as server_api from '../../../common/src/server_api.ts';
import { localStorageGet, LocalStorageKey } from '../data/client_local_storage.ts';

export function reportCrash(event: ErrorEvent) {
  // avoid reporting twice for same error
  // "reported" is a made up property - this works because the same error object is used the second time around
  if (event.error.reported) {
    return false;
  }
  event.error.reported = true;
  const details =
    event.target instanceof HTMLElement
      ? `Resource failed: ${event.target.tagName}, ${event.target.localName}, ${event.target.id}, ${event.target.className}`
      : '';
  const crashDescription = `${event.message}\n${event.filename}:${event.lineno}:${event.colno}\n${details}\n${event.error.stack}`;
  void reportCrashDescription(crashDescription);
  return false;
}

// Files a crash issue (and so a crash email, unless the server knows the description as a handled
// condition) for a problem the app caught rather than an uncaught error. Resolves once the issue has
// been sent, or failed to send - never rejects - so a caller about to reload the page can wait for it.
export function reportCrashDescription(crashDescription: string): Promise<void> {
  console.error(`Reporting error ${crashDescription}`);
  const bundleHash = localStorageGet(LocalStorageKey.BundleHash);
  const description: CrashDescription = {
    tag: IssueTag.Crash,
    description: crashDescription,
    bundleHash,
  };
  return server_api
    .addIssue({
      timestamp: Date.now(),
      description,
    })
    .catch((e) => console.log(`Failed to report the error: ${e?.message ?? e}`));
}
